var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProactivebyNature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9659 21.9324L27.5889 22.3094L27.6918 22.8325L28.4758 26.8167L28.4759 26.8169C28.6192 27.5447 28.387 28.2955 27.8699 28.8126L22.4346 34.2479L19.5919 27.6062L19.516 27.4289L19.3797 27.2926L12.7074 20.6203L12.5711 20.484L12.3938 20.4081L5.75027 17.5646L11.1856 12.1159C11.4447 11.8604 11.7621 11.6716 12.1103 11.5658C12.4583 11.4601 12.8268 11.4404 13.1841 11.5083L17.1637 12.3074L17.6889 12.4129L18.0676 12.0341C23.0159 7.08584 27.3424 5.50303 30.3543 5.11033C31.8687 4.91289 33.074 5.01314 33.887 5.15653C34.2112 5.21371 34.4731 5.27778 34.6674 5.33264C34.7222 5.52685 34.7863 5.78879 34.8435 6.11299C34.9869 6.92598 35.0871 8.13133 34.8897 9.64566C34.497 12.6576 32.9142 16.9841 27.9659 21.9324Z",
    stroke: "#2E2E2E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.283 26L10.2853 26C11.0198 25.9983 11.7382 26.2149 12.3494 26.6225C12.9606 27.0301 13.437 27.6102 13.718 28.2893C13.9991 28.9684 14.0721 29.7157 13.9278 30.4364C13.7835 31.1571 13.4283 31.8186 12.9076 32.3369L12.9057 32.3388C12.6076 32.637 11.9562 32.993 10.9834 33.3512C10.0496 33.6951 8.95018 33.9956 7.88416 34.2444C6.88782 34.4769 5.93872 34.6601 5.21063 34.7892C5.33967 34.0607 5.52284 33.1109 5.75532 32.1139C6.004 31.0474 6.30439 29.9474 6.64815 29.0131C7.00624 28.0399 7.36215 27.3881 7.66026 27.0898C8.33051 26.4193 9.25782 26 10.283 26Z",
    stroke: "#C63031",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 13,
    r: 2,
    stroke: "#2E2E2E",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProactivebyNature);
export default __webpack_public_path__ + "static/media/Proactive by Nature.43cbb2aff0b3ada658d57f041ae95c24.svg";
export { ForwardRef as ReactComponent };